import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { stringFieldDefault } from "components/Utility";
import { getSubjectAddressFields } from "typeConstants/mCardDefinitions/addressFields";
import { MSpinner } from "components/Shared";

class SubjectAddress extends React.Component {

  constructor(props) {
    super(props);
    this.getFields = this.getFields.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.setCardControls = this.setCardControls.bind(this);

    this.cardControlMethods = null;
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isUpdating && prevProps.isUpdating) {
      this.props.getData(this.props.controlNumber);
    }
  }

  setCardControls(cm) {
    this.cardControlMethods = cm;
  }

  getFields() {
    const { address, county, state, geocode, rawAddress, onAddressClick } = this.props;
    return getSubjectAddressFields({
      address,
      county,
      state,
      geocode: `${geocode.latitude}, ${geocode.longitude}`,
      rawAddress,
    }, () => { if (onAddressClick) onAddressClick(address); });
  }

  handleEdit(arr, obj) {
    if (this.cardControlMethods.runValidation(true)) {
      this.props.update(this.props.controlNumber, obj);
    }
  }

  render() {
    const { className, address } = this.props;
    if (!address) {
      return <MSpinner />;
    }
    return (
      <MCard
        title="Subject Property"
        className={className}
        fields={this.getFields()}
        isEditable={this.props.isEditable}
        onEditFinished={this.handleEdit}
        getControlMethods={this.setCardControls}
      />
    );
  }
}

SubjectAddress.defaultProps = {
  address: stringFieldDefault,
  county: stringFieldDefault,
  state: stringFieldDefault,
  geocode: {},
  rawAddress: {}
};

SubjectAddress.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  address: PropTypes.string,
  county: PropTypes.string,
  state: PropTypes.string,
  geocode: PropTypes.object,
  className: PropTypes.string,
  rawAddress: PropTypes.object,
  isEditable: PropTypes.bool,
  update: PropTypes.func,
  isUpdating: PropTypes.bool,
  getData: PropTypes.func,
  onAddressClick: PropTypes.func,
};

export default SubjectAddress;
